import { BaseHead, CellOfRow } from '@components/tables';
import { appConfig } from '@configs/index';
import { PCNDuplicate } from '@EcamModel/model';
import { Box, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import ListNoData from '@pages/cameras/list/components/NoDataCameras';
import { Link } from 'react-router-dom';
import { formatUKDate } from 'src/helpers';
import { statusMapping } from './DuplicatePCDetail';

type Props = {
    pcnDuplicatesAdditionalInformation: PCNDuplicate[];
    pcId?: number;
};

export default function ListPCNDuplicatesAdditionalInformation(props: Props) {
    const { pcnDuplicatesAdditionalInformation, pcId } = props;
    return (
        <Stack border={'1px solid #DDDDDD'} p={2} borderRadius={1}>
            {pcnDuplicatesAdditionalInformation.length > 0 ? (
                <TableContainer component={Box}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <BaseHead align="left" title="Reference" />
                                <BaseHead align="center" title="Source" />
                                <BaseHead align="center" title="Step" />
                                <BaseHead align="center" title="Status" />
                                <BaseHead align="center" title="Canceled reason" />
                                <BaseHead align="center" title="Issued date" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pcnDuplicatesAdditionalInformation?.map((item, index) => {
                                return (
                                    <TableRow key={item.id!}>
                                        <CellOfRow
                                            value={
                                                <Link
                                                    to={
                                                        item.source === 'Stella'
                                                            ? `${appConfig.apps.stella}/ContraventionManagement/Contravention/Details/${item.id}`
                                                            : `/verification/${pcId}/${item.id}`
                                                    }
                                                    target={'_blank'}
                                                >
                                                    {item.reference ?? ' '}
                                                </Link>
                                            }
                                            align="left"
                                        />
                                        <CellOfRow
                                            value={<Typography component={'span'}>{item.source}</Typography>}
                                            align="center"
                                        />
                                        <CellOfRow
                                            value={<Typography component={'span'}>{item.step}</Typography>}
                                            align="center"
                                        />
                                        <CellOfRow
                                            value={
                                                <Typography component={'span'}>{statusMapping[item.status]}</Typography>
                                            }
                                            align="center"
                                        />
                                        <CellOfRow
                                            value={
                                                <Typography component={'span'}>{item.cancellationReason}</Typography>
                                            }
                                            align="center"
                                        />
                                        <CellOfRow
                                            value={
                                                <Typography component={'span'}>
                                                    {formatUKDate(item?.firstIssuedDate!)}
                                                </Typography>
                                            }
                                            align="center"
                                        />
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <ListNoData />
            )}
        </Stack>
    );
}
